<template>
  <div class="container">
    <h2 class="section-title mb-2 h1">INFORMASI</h2>
    <p class="text-center text-muted h5">
      Dewan Pengurus
    </p>
    <div v-if="loading">Memuat Dewan Pengurus...</div>
    <div v-else-if="error">{{ error }}</div>
    <div v-else class="gallery">
      <div v-for="product in products" :key="product.id" class="product-card">
        <img
          :src="`https://mui-kendal.or.id/pengurus/assets/files/${product.image}`"
          :alt="product.nama_pejabat"
          class="product-image"
        />
        <h5>{{ product.nama_pejabat }}</h5>
        <!-- <p>{{ product.jabatan }}</p> -->
        <p class="price">{{product.jabatan}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      products: [],
      loading: true,
      error: null,
    };
  },
  methods: {
    async fetchProducts() {
      try {
        const response = await axios.get(
          "https://mui-kendal.or.id/pengurus/Api/perangkat"
        );
        this.products = response.data;
      } catch (err) {
        this.error = "Gagal memuat produk. Coba lagi nanti.";
      } finally {
        this.loading = false;
      }
    },
    formatPrice(price) {
      return new Intl.NumberFormat("id-ID", {
        style: "currency",
        currency: "IDR",
      }).format(price);
    },
  },
  created() {
    this.fetchProducts();
  },
};
</script>

<style scoped>
 .section-title{
	text-align:center;
	color:#007b5e;
	margin-bottom:50px;
	text-transform:uppercase;
}
.gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
  padding: 16px;
}
.product-card {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  text-align: center;
  background: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
.product-image {
  width: 100%;
  height: 150px;
  object-fit: cover;
  border-radius: 8px;
}
.price {
  font-weight: bold;
  color: #4caf50;
}
</style>
